export const normaliseProductColor = (color: string) => {
  return color
    .normalize('NFD')
    .replace(/ß/g, 'ss')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replaceAll(' ', '_')
    .trim()
}
